<template>
  <div id="reviewslistmaharaja">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div class="datepickerwrap">
      <div class="leftcontent wrapitem">
        <div class="datebox custom_dropdown">
          <div @click="showWebsiteMenu = !showWebsiteMenu" class="custom_dropdown_wrap">
            <span class="custom_dropdown_title">{{ selected_website_label }}</span>
            <i class="fa fa-angle-down" style="font-size: 17px"></i>
          </div>
          <div class="custom_websiteMenu" v-if="showWebsiteMenu">
            <span
              style="cursor: pointer; font-size: 9px; float: right; color: #a48cca"
              @click="showWebsiteMenu = false"
              ><i class="fa fa-times"></i> Close
            </span>
            <div
              v-for="d in websiteMenuItems"
              :key="d.optgroup"
              class="custom_websiteMenuItems"
            >
              <div class="custom_optgroup">{{ d.optgroup }}</div>
              <div
                :class="{ active: selected_website == op.key }"
                class="custom_option"
                v-for="op in d.options"
                :key="d.optgroup + '_' + op.key"
              >
                <input
                  @change="customOptionSelected(d.optgroup, op.key, op.label, op.check)"
                  type="checkbox"
                  v-model="op.check"
                />
                <span>{{ op.label }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="datebox">
          <select
            v-model="device"
            @change="siteDeviceChange"
            class="form-control text-uppercase"
          >
            <option value="grinder">Grinder</option>
            <option value="heater">Heater</option>

            <!-- <option value="dresses">Dresses</option>
            <option value="jeans">Jeans</option> -->
          </select>
        </div>
        <div class="datebox">
          <button
            @click="siteDeviceChange"
            class="btn btn-block weavrpurple"
            type="button"
          >
            <span style="font-size: 13px">Submit</span>
          </button>
        </div>
        <div class="datebox custom_dropdown">
          <div @click="showProductModal" class="custom_dropdown_wrap">
            <span class="custom_dropdown_title">{{ selectedProduct.key }} &nbsp;</span>
            <i style="font-size: 17px" class="fa fa-angle-down"></i>
          </div>
        </div>
        <div class="datebox">
          <datepicker
            placeholder="From"
            @input="refreshReview"
            v-model="reviewStartDate"
          />
        </div>
        <div class="datebox">
          <datepicker
            v-model="reviewEndDate"
            class="picker-left"
            placeholder="To"
            @input="refreshReview"
          />
        </div>
      </div>
      <div class="righcontent wrapitem">
        <button
          @click="backToSov"
          style="float: right"
          class="btn weavrpurple"
          type="button"
        >
          <i class="fa fa-arrow-left"></i>
          <span style="font-size: 13px"> Back</span>
        </button>
        <button
          @click="goToSentiments"
          style="float: right; margin-right: 5px"
          class="btn weavrpurple"
          type="button"
        >
          <span style="font-size: 13px">Show Sentiments</span>
        </button>
      </div>
    </div>
    <div class="container-fluid">
      <div class="card" style="padding: 10px; position: relative">
        <b-row style="justify-content: center; margin-top: 10px">
          <div class="col-md-*">
            <p style="margin-bottom: 0; padding: 7px">Ratings:</p>
          </div>
          <div class="col-md-3">
            <select v-model="reviewsRatingExp" class="form-control text-uppercase">
              <option value="eq">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="col-md-2 pl-0">
            <input
              v-model="reviewsRatingInput"
              style="border: 1px solid silver !important"
              class="form-control filval"
              type="text"
              placeholder="Enter Value"
            />
            <input
              v-if="reviewsRatingExp == 'between'"
              v-model="reviewsRatingInput2"
              style="border: 1px solid silver !important"
              class="form-control filval"
              type="text"
              placeholder="Enter Value"
            />
          </div>
          <div class="col-md-1 pl-0">
            <button @click="refreshReview" class="btn filval btn-primary">Apply</button>
          </div>
          <div class="col-md-5 pl-0" style="text-align: right">
            <span class="lastUpdated">
              Last Updated: {{ moment(reviewsData.last_updated).format("MMM DD, YY") }}
            </span>
          </div>
        </b-row>
        <button
          style="margin-left: 4px; position: absolute; right: 13px; top: 19px"
          @click="exportData"
          class="btn filval btn-primary"
        >
          Export
        </button>
        <table id="myTable">
          <thead class="thead-normal">
            <tr>
              <th style="width: 9%">Partner</th>
              <th style="width: 14%">Product Name</th>
              <th style="width: 7%">Review<br />Date</th>
              <th style="width: 5%">Rating</th>
              <th>Review Text</th>
              <th style="width: 8%">Overall Rating</th>
              <th style="width: 8%">Total Reviews</th>
            </tr>
          </thead>
          <tfoot style="display: table-row-group">
            <tr>
              <th style="width: 9%">Partner</th>
              <th style="width: 14%">Product Name</th>
              <th style="width: 7%">Review<br />Date</th>
              <th style="width: 5%">Rating</th>
              <th>Review Text</th>
              <th style="width: 8%">Overall Rating</th>
              <th style="width: 8%">Total Reviews</th>
            </tr>
          </tfoot>
          <tbody class="tbody-normal" style="font-family: inherit">
            <tr v-for="(d, i) in reviewsData.data">
              <td :data-order="d.channel">{{ d.channel }}</td>
              <td>
                <div
                  style="
                    text-align: left;
                    width: 200px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  <a :title="d.product_name" :href="d.product_link">{{
                    d.product_name
                  }}</a>
                </div>
              </td>
              <td :data-order="d.review_date">{{ d.review_date }}</td>
              <td :data-order="d.rating">{{ d.rating }}</td>
              <td :data-order="d.review" style="text-align: left; min-width: 200px">
                <span v-show="d.review.length < 185">{{ d.review }}</span>
                <span v-show="d.review.length >= 185">
                  <span v-show="!reviewLayoutExpand.includes(i)"
                    >{{ d.review.slice(0, 185) }}...</span
                  >
                  <span v-show="reviewLayoutExpand.includes(i)">{{ d.review }}</span>

                  <span
                    @click="expandReview(i)"
                    v-show="!reviewLayoutExpand.includes(i)"
                    style="color: #167495; cursor: pointer"
                    >Expand</span
                  >
                  <span
                    @click="collapseReview(i)"
                    v-show="reviewLayoutExpand.includes(i)"
                    style="color: #167495; cursor: pointer"
                  >
                    Collapse</span
                  >
                </span>
              </td>
              <td :data-order="d.product_rating">{{ d.product_rating }}</td>
              <td :data-order="d.review_count">{{ d.review_count }}</td>
              <!-- <td>
                <div  class="each-review">
                  
                  <div class="usericon">
                    <i class="fa fa-user" style="font-size: 15px; color: silver;"></i>
                  </div>
                  <div class="username">
                    {{ d.person_name }}
                  </div>
                <div class="usertimestamp">
                  {{ d.review_date }}
                </div>  
                <div class="helpful">
                  Helpful: {{ d.found_helpful }}
                    <a :href="d.review_link" target="_blank">
                      Link
                    </a>
                </div>
                <div class="helpful" style="margin-right:5px">
                  Rating: {{d.rating}}
                 
                </div>
                <div class="usertext" style="text-align: justify;">
                  
                  {{ d.review }}
                </div>
              </div>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="card" style="padding: 5px">
        <div class="space-between-header">
          <h4 class="m-0">Top Positive Keywords</h4>
        </div>
        <div v-show="Object.keys(multiProdChart.positive).length">
          <highcharts
            v-if="activeMultiChart.positive"
            :options="multiProdChart.positive"
          ></highcharts>
        </div>
      </div>
      <div class="card" style="padding: 5px; display: none">
        <div class="space-between-header">
          <h4 class="m-0">Top Negative Keywords</h4>
        </div>
        <div v-show="Object.keys(multiProdChart.negative).length">
          <highcharts
            v-if="activeMultiChart.negative"
            :options="multiProdChart.negative"
          ></highcharts>
        </div>
      </div> -->
    </div>

    <b-modal size="lg" title="Select  " v-model="isProductModal">
      <b-row>
        <div class="col-md-12">
          <div style="position: relative">
            <input
              style="
                border-radius: 0;
                padding: 6px;
                font-size: 11px;
                height: 30px;
                padding-left: 30px;
              "
              class="form-control"
              v-model="schProduct"
              type="text"
              placeholder="Search"
            />
            <i
              style="position: absolute; left: 0; top: 0; padding: 8px"
              class="fa fa-search"
            ></i>
          </div>
        </div>
      </b-row>
      <!-- <b-row class="pt-2"> 
        <div class="col-md-4" v-if="checkChannel()">
          <div class="row">
            <div class="col-md-3">
              <p style="margin-bottom: 0;padding: 7px;">OEM:</p>
            </div>   
            <div class="col-md-9" >
              <select  v-model="brandFilter" @change="changeFilter"  class="form-control">
                <option value="">All</option>
                <option style="text-transform:capitalize" v-for="d in filterKeys.brand" :value="d" :key="d">{{ d.replace('msi','MSI').replace('hp','HP') }}</option>
              </select>
            </div>    
          </div>  
        </div>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-2">
              <p style="margin-bottom: 0;padding: 7px;">Processor:</p>
            </div>   
            <div class="col-md-6">
              <select  v-model="cpuFilter" @change="changeFilter" class="form-control fluid">
                <option value="">All</option>
                <option style="text-transform:capitalize" v-for="d in filterKeys.processor_type" :value="d" :key="d">{{ d.replace('amd','AMD') }}</option>
              </select>
            </div>    
          </div>  
        </div>
      </b-row>
      <b-row style="margin-top: 10px;">  
          <div class="col-md-1">
            <p style="margin-bottom: 0;padding: 7px;">Ratings:</p>
          </div>
          <div class="col-md-3   ">
            <select v-model="ratingExp" class="form-control text-uppercase">
              <option value="eq">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="col-md-2 pl-0">
           <input min="0" max="5" v-model="ratingInput1"  style="border: 1px solid silver !important;"  class="form-control filval" type="number" placeholder="Enter Value">
         
          </div>
          <div v-if="ratingExp=='between'" class="col-md-2 pl-0">
           <input min="0" max="5" v-model="ratingInput2"  style="border: 1px solid silver !important;"  class="form-control filval" type="number" placeholder="Enter Value">
         
          </div>
          <div  class="col-md-4 pl-0">
            <button @click="applyRatingFilter"  class="btn filval btn-primary mr-1"> Apply </button>
            <button @click="removeRatingFilter"  class="btn filval btn-danger"> Remove </button>
          </div>
      </b-row>  
      <b-row style="margin-top: 10px;">  
        <div class="col-md-3 pr-0">
          <div style="padding: 5px; height: 30px; border: none; background: rgb(138, 135, 232); color: white;">
            <input @change="changeFilter" v-model="fourKSeries" type="checkbox" style="float: left; margin-right: 6px; margin-top: 3px;">
            <span>4000 Series</span>
          </div>
        </div>
        <div class="col-md-3 pl-1">
          <div style="padding: 5px; height: 30px; border: none; background: rgb(138, 135, 232); color: white;">
            <input @change="changeFilter" v-model="fiveKSeries" type="checkbox" style="float: left; margin-right: 6px; margin-top: 3px;">
            <span>5000 Series</span>
          </div>
        </div>
        
      </b-row>   -->
      <div class="space-between-header" style="padding-top: 20px">
        <h6 class="m-0">Products:</h6>
      </div>
      <div style="padding-top: 0px; cursor: pointer; height: 300px; overflow-y: scroll">
        <div
          :class="{ selectedProduct: selectedProduct.key == 'all' }"
          class="eachProduct"
          @click="selectProductNow({ key: 'all' })"
          style="padding: 4px; border-bottom: 1px solid #e6e6e6"
        >
          All
        </div>
        <div
          :class="{ selectedProduct: selectedProduct.key == d.key }"
          v-if="checkSearchFilter(d.key)"
          class="eachProduct"
          @click="selectProductNow(d)"
          style="padding: 4px; border-bottom: 1px solid #e6e6e6"
          :key="d.key"
          v-for="d in productOptions"
        >
          <span
            style="color: white; background: #8a87e8; margin-right: 10px; padding: 3px"
            >{{ d.channel_name }}</span
          >
          <span>{{ d.key }} </span>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "sov",
  components: { Datepicker },
  data: function () {
    return {
      selected_website: "https://www.amazon.in",
      websiteMenuItems: [
        {
          optgroup: "RETAIL",
          options: [
            { key: "all", label: "All" },
            { key: "https://www.amazon.in", label: "Amazon", check: false },
            // { key: "https://www.flipkart.com", label: "Flipkart", check: true },
          ],
        },
      ],
      websitesUrls: {
        // "https://www.flipkart.com": "flipkart",
        "https://www.amazon.in": "amazon",
      },
      reviewStarData: [],
      sentimentData: {},
      sentimentChart: {},
      activeSentimentChart: false,
      selectedProduct: { key: "all" },
      productOptions: [],
      productOptionsFull: [],
      reviewStartDate: "2019-01-01",
      reviewEndDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      loader: true,
      modalTitle: "",
      modalSentimentType: "",
      keywordChartData: {},
      showModal: false,
      modalLoader: false,
      chartDataKey: "original_frequency",
      chartDataMapper: {
        original_score: "Score",
        original_frequency: "Frequency",
        reviews_count: "Reviews Count",
      },
      interval: "month",
      activeModalChart: false,
      modalData: {},
      isProductModal: false,
      schProduct: "",
      reviewLayoutExpand: [],
      deviceMapper: {
        tshirts: "T shirts",
        dresses: "Dresses",
        jeans: "Jeans",
      },
      device: "grinder",
      ratingInput1: "",
      ratingExp: "eq",
      ratingInput2: "",
      pickProduct: false,
      filterChanged: false,
      cpuFilter: "",
      brandFilter: "",
      filterKeys: {
        brand: [],
        processor_type: [],
      },
      reviewsRatingExp: "eq",
      reviewsRatingInput: "",
      reviewsRatingInput2: "",
      reviewsData: {},
      updateSelectedProduct: false,
      moment: moment,
      fourKSeries: false,
      fiveKSeries: false,
      showWebsiteMenu: false,
      selected_website_label: "Amazon",
      selected_website_array: ["https://www.amazon.in"],
      selected_website_channel_array: ["amazon"],
      multiProdChart: {
        positive: {},
        negative: {},
      },
      activeMultiChart: {
        positive: false,
        negative: false,
      },
    };
  },

  mounted() {
    if (localStorage.selected_website) {
      this.device = localStorage.selected_category;
      this.selected_website_array = [localStorage.selected_website];
      this.selected_website_channel_array = [
        this.websitesUrls[localStorage.selected_website],
      ];
      for (let [i, r] of this.websiteMenuItems.entries()) {
        for (let [ii, rr] of r.options.entries()) {
          if (rr.key == localStorage.selected_website) {
            this.selected_website_label = rr.label;
            rr.check = true;
          }
        }
      }
    } else {
      this.device = "grinder";
      this.websiteMenuItems[0].options[1].check = true;
    }

    if (localStorage.cpuFilter) this.cpuFilter = localStorage.cpuFilter;
    if (localStorage.brandFilter) this.brandFilter = localStorage.brandFilter;
    if (localStorage.ratingExp) this.ratingExp = localStorage.ratingExp;
    if (localStorage.ratingInput1) this.ratingInput1 = localStorage.ratingInput1;
    if (localStorage.ratingInput2) this.ratingInput2 = localStorage.ratingInput2;
    if (localStorage.fourKSeries) this.fourKSeries = JSON.parse(localStorage.fourKSeries);
    if (localStorage.fiveKSeries) this.fiveKSeries = JSON.parse(localStorage.fiveKSeries);

    if (localStorage.reviewStartDate) {
      this.reviewStartDate = localStorage.reviewStartDate;
      this.reviewEndDate = localStorage.reviewEndDate;
    }
    this.getProducts();
  },
  methods: {
    processMultiProductChartData(data, type) {
      let self = this;
      let cat = [];
      let seriesData = [];
      let seriesObj = {};
      for (let [idx, ds] of data.entries()) {
        cat.push(ds.token);
        for (let [idx2, ds2] of ds.products.entries()) {
          if (seriesObj.hasOwnProperty(ds2.product_name)) {
            seriesObj[ds2.product_name].push(ds2.count);
          } else {
            seriesObj[ds2.product_name] = [ds2.count];
          }
        }
      }
      for (let [key, value] of Object.entries(seriesObj)) {
        seriesData.push({ name: key, data: value });
      }

      this.multiProdChart[type] = {
        chart: {
          type: "column",
          height: 220,
        },
        credits: { enabled: false },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },
        xAxis: {
          categories: cat,
          crosshair: true,
        },
        legend: { align: "left" },
        yAxis: {
          min: 0,
          title: {
            text: "Frequency",
          },
        },
        tooltip: {
          shared: true,
        },
        series: seriesData,
      };
      setTimeout(function () {
        self.activeMultiChart[type] = true;
      }, 10);
    },
    getMultiProductChart() {
      let self = this;
      self.loader = true;
      let payload = {
        start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
        interval: self.revInterval,
        client: "maharaja",
        item_category: self.device,
        channel: self.selected_website_channel_array,
      };
      if (self.reviewsRatingInput) {
        payload["rating"] = {};
        if (self.reviewsRatingExp != "between") {
          payload["rating"][self.reviewsRatingExp] = self.reviewsRatingInput;
        } else {
          payload["rating"]["lte"] = self.reviewsRatingInput2;
          payload["rating"]["gte"] = self.reviewsRatingInput;
        }
      }
      if (self.selectedProduct.key != "all") {
        payload["product_name"] = [self.selectedProduct.key];
      }
      if (self.ratingInput1 || self.fourKSeries || self.fiveKSeries) {
        if (self.pickProduct) {
          if (self.selectedProduct.key != "all")
            payload["product_name"] = [self.selectedProduct.key];
          else {
            payload["product_name"] = [];
            for (let [ii, rr] of this.productOptions.entries()) {
              payload["product_name"].push(rr.key);
            }
          }
        } else {
          payload["product_name"] = [];
          for (let [ii, rr] of this.productOptions.entries()) {
            payload["product_name"].push(rr.key);
          }
        }
      }
      let keys = ["positive", "negative"];
      for (let [i, d] of keys.entries()) {
        self.activeMultiChart[d] = false;
        self.multiProdChart[d] = {};
        const url = "/api/voc/" + d + "_keywords/graph";
        self.$http.post(url, payload).then(
          (response) => {
            self.processMultiProductChartData(response.body.data, d);
          },
          (err) => {
            self.loader = false;
          }
        );
      }
    },
    customOptionSelected(optgroup, value, label, check) {
      let self = this;
      if (value != "all") {
        if (check) {
          self.selected_website_label = label;
          this.selected_website_array.push(value);
          this.selected_website_channel_array.push(this.websitesUrls[value]);
          // for (let [i, r] of this.websiteMenuItems.entries())
          // {
          //   if(r.optgroup == optgroup)
          //   {
          //     let allTick = true
          //     for (let [ii, rr] of r.options.entries())
          //     {
          //       if(rr.check == false) allTick = false
          //     }
          //     if(allTick)
          //     {
          //       r.options[0].check = true

          //     }
          //   }
          // }
        } else {
          if (this.selected_website_array.includes(value))
            this.selected_website_array.splice(
              this.selected_website_array.indexOf(value),
              1
            );
          if (this.selected_website_channel_array.includes(this.websitesUrls[value]))
            this.selected_website_channel_array.splice(
              this.selected_website_channel_array.indexOf(this.websitesUrls[value]),
              1
            );
          for (let [i, r] of this.websiteMenuItems.entries()) {
            if (r.optgroup == optgroup) {
              r.options[0].check = false;
            }
          }
        }
      } else {
        for (let [i, r] of this.websiteMenuItems.entries()) {
          if (r.optgroup == optgroup) {
            for (let [ii, rr] of r.options.entries()) {
              if (check) {
                rr.check = true;
                if (rr.key != "all") {
                  this.selected_website_array.push(rr.key);
                  this.selected_website_channel_array.push(this.websitesUrls[rr.key]);
                }
              } else {
                rr.check = false;
                if (this.selected_website_array.includes(rr.key))
                  this.selected_website_array.splice(
                    this.selected_website_array.indexOf(rr.key),
                    1
                  );
                if (
                  this.selected_website_channel_array.includes(this.websitesUrls[rr.key])
                )
                  this.selected_website_channel_array.splice(
                    this.selected_website_channel_array.indexOf(
                      this.websitesUrls[rr.key]
                    ),
                    1
                  );
              }
            }
          }
        }
      }
    },
    siteDeviceChange() {
      let self = this;
      self.selectedProduct = { key: "all" };
      self.showWebsiteMenu = false;
      self.updateSelectedProduct = true;
      localStorage.selected_website = self.selected_website;
      localStorage.selected_category = self.device;
      self.getProducts();
    },
    exportData() {
      let self = this;
      self.loader = true;
      setTimeout(function () {
        let payload = {
          start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
          end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
          interval: self.revInterval,
          client: "maharaja",
          item_category: self.device,
        };
        if (self.reviewsRatingInput) {
          payload["rating"] = {};
          if (self.reviewsRatingExp != "between") {
            payload["rating"][self.reviewsRatingExp] = self.reviewsRatingInput;
          } else {
            payload["rating"]["lte"] = self.reviewsRatingInput2;
            payload["rating"]["gte"] = self.reviewsRatingInput;
          }
        }

        if (self.selected_website != "all") {
          payload["channel"] = self.selected_website_channel_array;
        }
        if (self.selectedProduct.key != "all") {
          payload["product_name"] = [self.selectedProduct.key];
        }
        if (self.ratingInput1) {
          if (self.pickProduct) {
            if (self.selectedProduct.key != "all")
              payload["product_name"] = [self.selectedProduct.key];
            else {
              payload["product_name"] = [];
              for (let [ii, rr] of this.productOptions.entries()) {
                payload["product_name"].push(rr.key);
              }
            }
          } else {
            payload["product_name"] = [];
            for (let [ii, rr] of this.productOptions.entries()) {
              payload["product_name"].push(rr.key);
            }
          }
        }

        const url = "/api/reviews/download/amd";
        self.$http.post(url, payload).then(
          (response) => {
            self.loader = false;
            window.location = response.body.data;
          },
          (err) => {
            self.loader = false;
          }
        );
      }, 100);
    },
    expandReview(i) {
      this.reviewLayoutExpand.push(i);
    },
    collapseReview(i) {
      let arIdx = this.reviewLayoutExpand.indexOf(i);
      this.reviewLayoutExpand.splice(arIdx, 1);
    },
    changeFilter() {
      this.pickProduct = false;
      this.selectedProduct = { key: "all" };
      localStorage.selected_product = JSON.stringify(this.selectedProduct);
      this.filterChanged = true;
      if (this.cpuFilter) localStorage.cpuFilter = this.cpuFilter;
      else delete localStorage.cpuFilter;
      if (this.brandFilter) localStorage.brandFilter = this.brandFilter;
      else delete localStorage.brandFilter;
      if (this.ratingExp) localStorage.ratingExp = this.ratingExp;
      else delete localStorage.ratingExp;
      if (this.ratingInput1) localStorage.ratingInput1 = this.ratingInput1;
      else delete localStorage.ratingInput1;
      if (this.ratingInput2) localStorage.ratingInput2 = this.ratingInput2;
      else delete localStorage.ratingInput2;
      if (this.fourKSeries) localStorage.fourKSeries = JSON.stringify(this.fourKSeries);
      else delete localStorage.fourKSeries;
      if (this.fiveKSeries) localStorage.fiveKSeries = JSON.stringify(this.fiveKSeries);
      else delete localStorage.fiveKSeries;
      this.filterActions();
    },
    removeRatingFilter() {
      this.ratingInput1 = "";
      this.ratingInput2 = "";
      if (localStorage.ratingExp) delete localStorage.ratingExp;
      if (localStorage.ratingInput1) delete localStorage.ratingInput1;
      if (localStorage.ratingInput2) delete localStorage.ratingInput2;
      this.changeFilter();
    },
    applyRatingFilter() {
      let self = this;
      if (self.ratingInput1 > 5) {
        alert("Rating value should be between 0 and 5");
        return false;
      }
      if (self.ratingInput1 < 0) {
        alert("Rating value should be between 0 and 5");
        return false;
      }
      if (self.ratingExp == "between") {
        if (self.ratingInput2 > 5) {
          alert("Rating value should be between 0 and 5");
          return false;
        }
        if (self.ratingInput2 < 0) {
          alert("Rating value should be between 0 and 5");
          return false;
        }
      }
      self.changeFilter();
    },
    checkChannel() {
      if (
        this.selected_website == "https://www.amazon.com" ||
        this.selected_website == "https://www.harveynorman.com.au" ||
        this.selected_website == "https://www.costco.com" ||
        this.selected_website == "https://www.walmart.com" ||
        this.selected_website == "https://global.jd.com" ||
        this.selected_website == "https://www.bestbuy.com" ||
        this.selected_website == "https://www.currys.co.uk" ||
        this.selected_website == "https://www.mediamarkt.de"
      ) {
        return true;
      } else {
        return false;
      }
    },
    checkSearchFilter(d) {
      let self = this;
      if (d.toLowerCase().indexOf(self.schProduct.toLowerCase()) != -1) {
        return true;
      } else {
        return false;
      }
    },
    goToSentiments() {
      let self = this;
      window.location = "#/sentiments-maharaja";
    },
    selectProductNow(d) {
      let self = this;
      self.selectedProduct = d;
      self.pickProduct = true;
      localStorage.selected_product = JSON.stringify(self.selectedProduct);
      self.refreshReview();
      self.isProductModal = false;
    },
    showProductModal() {
      let self = this;
      self.isProductModal = true;
    },
    formatDate(key, d) {
      let self = this;
      let obj = {
        day: moment(d).format("MMM DD, YY"),
        month: moment(d).format("MMM YY"),
        week: "",
      };
      if (self[key] == "week") {
        let end_date = moment(d).add(6, "days");
        let today = moment(self.reviewEndDate);
        if (end_date >= today) end_date = today;
        obj["week"] =
          moment(d).format("MMM DD, YY") + " - " + moment(end_date).format("MMM DD, YY");
      }
      return obj[this[key]];
    },
    backToSov() {
      window.location = "#/sov-maharaja";
    },
    changeSentimentType(d) {
      this.$nextTick(function () {
        this.modalSentimentType = d;
        this.getKeywordWiseData();
      });
    },
    getKeywordWiseData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      if (Object.keys(self.modalData).length) {
        $("#myTable").DataTable().destroy();
      }
      self.modalData = {};
      let url = "/api/reviews/keywordwise";
      url += "?keyword=" + self.modalTitle;
      url += "&product_name=" + self.selectedProduct.key;

      url += "&channel=" + self.websitesUrls[self.selected_website];
      if (self.modalSentimentType) url += "&sentiment_type=" + self.modalSentimentType;
      url += "&start_date=" + this.reviewStartDate + "&end_date=" + this.reviewEndDate;
      self.$http.get(url).then(
        (response) => {
          self.modalData = response.body;
          self.modalLoader = false;
          self.loader = false;
          if (!self.showModal) self.showModal = true;
        },
        (err) => {
          self.modalLoader = false;
          self.loader = false;
        }
      );
    },

    processChartData() {
      let category = [];
      let series = [];
      let comm_series = [];
      let datakeys = [
        { key: "positive", label: "Positive", color: "green" },
        { key: "negative", label: "Negative", color: "red" },
      ];
      let self = this;
      let new_key = "";
      let org_label = "";
      let com_label = "";
      if (this.chartDataKey == "original_frequency") {
        new_key = "frequency";
        org_label = "Frequency";
        com_label = "Cummulative Frequency";
      } else if (this.chartDataKey == "original_score") {
        new_key = "score";
        org_label = "Score";
        com_label = "Cummulative Score";
      } else {
        new_key = "cummulative_review_count";
        org_label = "Review Count";
        com_label = "Cummulative Review Count";
      }
      for (let [i, k] of datakeys.entries()) {
        if (this.keywordChartData.data[k.key]) {
          let obj = {};
          obj.name = k.label;
          obj.data = [];
          obj.color = k.color;
          let comm_obj = {};
          let format_date = "";
          comm_obj.name = k.label;
          comm_obj.data = [];
          comm_obj.color = k.color;
          for (let [idx, dataset] of this.keywordChartData.data[k.key].entries()) {
            category.push(self.formatDate("interval", dataset.date));
            obj.data.push(dataset[this.chartDataKey]);
            comm_obj.data.push(dataset[new_key]);
          }
          series.push(obj);
          comm_series.push(comm_obj);
        }
      }
      this.plotChart({ series: series, category: category }, "modalChart", org_label);
      this.plotChart(
        { series: comm_series, category: category },
        "cmodalChart",
        com_label
      );
    },
    plotChart(d, chartObj, chart_label) {
      var self = this;
      if (d.category.length) self.activeModalChart = true;
      else self.activeModalChart = false;
      this[chartObj] = {
        credits: {
          enabled: false,
        },
        chart: {
          height: 210,
        },
        title: {
          text: "",
        },
        subtitle: {
          text: "",
        },

        yAxis: {
          title: {
            text: chart_label,
          },
        },
        xAxis: {
          categories: d.category,
          crosshair: true,
          crosshair: {
            color: "rgba(166, 215, 238)",
            width: 2,
          },
        },
        tooltip: {
          formatter: function () {
            var mytooltip = this.points[0].key + "<br/>";
            for (var i = 0; i < this.points.length; i++) {
              mytooltip +=
                '<span style="color:' + this.points[i].series.color + '">\u25CF</span> ';
              mytooltip += this.points[i].series.name;
              mytooltip += " : <b> " + self.format(this.points[i].y) + "</b> <br/>";
            }
            return mytooltip;
          },
          shared: true,
        },
        plotOptions: {
          series: {
            lineWidth: 1.2,
            marker: {
              radius: 1.9,
            },
          },
        },
        series: d.series,
      };
    },
    refreshModal() {
      let self = this;
      self.reviewStartDate = moment(self.reviewStartDate).format("YYYY-MM-DD");
      self.reviewEndDate = moment(self.reviewEndDate).format("YYYY-MM-DD");
      this.getKeywordChartData();
      this.getKeywordWiseData();
    },
    openModal(keyword, type) {
      this.modalTitle = keyword;
      this.modalSentimentType = type;
      this.refreshModal("datecomponent");
    },
    getKeywordChartData() {
      let self = this;
      self.modalLoader = true;
      self.loader = true;
      self.$nextTick(function () {
        self.keywordChartData = {};
        let url = "/api/reviews/keywisesentdata?interval=" + self.interval;
        url += "&keyword=" + self.modalTitle;
        url += "&product_name=" + self.selectedProduct.key;
        url += "&channel=" + self.websitesUrls[self.selected_website];
        if (self.modalSentimentType) url += "&sentiment_type=" + self.modalSentimentType;

        url += "&start_date=" + this.reviewStartDate + "&end_date=" + this.reviewEndDate;
        self.$http.get(url).then(
          (response) => {
            self.keywordChartData = response.body;
            self.modalLoader = false;
            self.loader = false;
            self.processChartData();
          },
          (err) => {
            self.modalLoader = false;
            self.loader = false;
          }
        );
      });
    },
    drawGaugeChart(word, positive, negative) {
      let self = this;
      let series = [];
      let value1 = Number(positive);
      let value2 = Number(negative);
      if (value1 && value2) {
        let obj = {};
        obj.name = "Positive";
        obj.color = "#7fc557";
        obj.y = value1;
        series.push(obj);
        let obj2 = {};
        obj2.name = "Negative";
        obj2.color = "#fb7b63";
        obj2.y = value2;
        series.push(obj2);
      } else {
        if (!value1) {
          let obj = {};
          obj.name = "Negative";
          obj.color = "#fb7b63";
          obj.y = value2;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "whitesmoke";
          obj2.y = 100 - value2;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
        if (!value2) {
          let obj = {};
          obj.name = "Positive";
          obj.color = "#7fc557";
          obj.y = value1;
          series.push(obj);
          let obj2 = {};
          obj2.name = "other";
          obj2.color = "whitesmoke";
          obj2.y = 100 - value1;
          obj2.dataLabels = { enabled: false };
          series.push(obj2);
        }
      }
      this.sentimentChart[word] = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          margin: [0, 0, 0, 0],
          padding: [0, 0, 0, 0],
          height: 110,
          width: 180,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        tooltip: {
          formatter() {
            if (this.point.name == "other") {
              return false;
            }
            var mytooltip = "";
            // console.log(this.point)
            mytooltip +=
              '<span style="color:' + this.point.color + '!important">\u25CF</span> ';
            mytooltip += this.point.name;
            mytooltip += " : <b> " + self.format(this.point.y) + "%</b> <br/>";
            return mytooltip;
          },
        },
        plotOptions: {
          series: {
            borderWidth: 0,
          },
          pie: {
            dataLabels: {
              enabled: true,
              distance: -15,
              format: "{point.y:.1f}",
              style: {
                fontSize: 11,
              },
              color: "black",
            },
            showInLegend: true,
            startAngle: -90,
            endAngle: 90,
            size: "100%",
            center: ["50%", "57%"],
          },
        },
        legend: {
          enabled: false,
          itemStyle: {
            fontSize: 9,
            fontWeight: 1,
          },
        },
        series: [
          {
            type: "pie",
            innerSize: "59%",
            data: series,
          },
        ],
      };
    },
    getSentiment() {
      let self = this;
      self.loader = true;
      let payload = {
        product_name: self.selectedProduct.key,
        channel: self.websitesUrls[self.selected_website],
        start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
        item_category: self.device,
      };
      const url = "/api/websites/review_sentiment";
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.sentimentData = response.body.table;
          for (let [y, td] of response.body.table.entries()) {
            if (td.positive_score == null) {
              td.positive_score = 0;
            }
            if (td.negative_score == null) {
              td.negative_score = 0;
            }
            self.drawGaugeChart(td.word, td.positive_score, td.negative_score);
          }
        },
        (err) => {
          self.loader = false;
        }
      );
    },
    refreshReview() {
      let self = this;
      localStorage.reviewStartDate = moment(this.reviewStartDate).format("YYYY-MM-DD");
      localStorage.reviewEndDate = moment(this.reviewEndDate).format("YYYY-MM-DD");

      if (self.selectedProduct.key) {
        localStorage.selected_product = JSON.stringify(self.selectedProduct);
        self.getReviews();
        self.getMultiProductChart();
      }
    },
    getReviews() {
      let self = this;
      self.loader = true;
      let payload = {
        start_date: moment(self.reviewStartDate).format("YYYY-MM-DD"),
        end_date: moment(self.reviewEndDate).format("YYYY-MM-DD"),
        interval: self.revInterval,
        client: "maharaja",
        item_category: self.device,
        channel: self.selected_website_channel_array,
      };
      if (self.brandFilter) {
        payload["brand"] = self.brandFilter;
      }
      if (self.cpuFilter) {
        payload["processor"] = self.cpuFilter;
      }
      if (self.reviewsRatingInput) {
        payload["rating"] = {};
        if (self.reviewsRatingExp != "between") {
          payload["rating"][self.reviewsRatingExp] = self.reviewsRatingInput;
        } else {
          payload["rating"]["lte"] = self.reviewsRatingInput2;
          payload["rating"]["gte"] = self.reviewsRatingInput;
        }
      }

      if (self.selectedProduct.key != "all") {
        payload["product_name"] = [self.selectedProduct.key];
      }
      if (self.ratingInput1 || self.fourKSeries || self.fiveKSeries) {
        if (self.pickProduct) {
          if (self.selectedProduct.key != "all")
            payload["product_name"] = [self.selectedProduct.key];
          else {
            payload["product_name"] = [];
            for (let [ii, rr] of this.productOptions.entries()) {
              payload["product_name"].push(rr.key);
            }
          }
        } else {
          payload["product_name"] = [];
          for (let [ii, rr] of this.productOptions.entries()) {
            payload["product_name"].push(rr.key);
          }
        }
      }
      if (Object.keys(self.reviewsData).length) {
        $("#myTable").DataTable().destroy();
      }
      self.reviewsData = {};

      const url = "/api/reviews/list";
      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.reviewsData = response.body;
          self.$nextTick(function () {
            if (self.reviewsData.data.length)
              $("#myTable").dataTable({
                searching: true,
                info: false,
                bLengthChange: false,
                pageLength: 20,
                autoWidth: false,
                initComplete: function () {
                  this.api()
                    .columns()
                    .every(function () {
                      var column = this;

                      var select = $('<select><option value="">All</option></select>')
                        .appendTo($(column.footer()).empty())
                        .on("change", function () {
                          var val = $.fn.dataTable.util.escapeRegex($(this).val());
                          column.search(val ? "^" + val + "$" : "", true, false).draw();
                        });
                      let arr = [];
                      let sortedArr = [];
                      column
                        .data()
                        .unique()
                        .sort()
                        .each(function (d, j) {
                          if (!d.includes("<span") && !d.includes("<div")) {
                            arr.push(d);
                          } else {
                            var myVal = $(d).text();
                            arr.push(myVal);
                          }
                        });

                      sortedArr = arr.sort((a, b) =>
                        a.localeCompare(b, navigator.languages[0] || navigator.language, {
                          numeric: true,
                          ignorePunctuation: true,
                        })
                      );

                      for (let [idx, ds] of sortedArr.entries()) {
                        select.append('<option value="' + ds + '">' + ds + "</option>");
                      }
                    });
                },
              });
          });
          setTimeout(function () {
            $("#myTable_filter").attr("style", "display:none");
          }, 10);
        },
        (err) => {
          self.loader = false;
        }
      );
    },
    getProducts() {
      let self = this;
      self.loader = true;
      self.productOptions = [];
      self.selectedProduct = {};
      self.productOptionsFull = [];
      const url = "/api/websites/website_products";
      let payload = {};
      payload["website"] = this.selected_website_array;
      payload["item_category"] = self.device;
      payload["start_date"] = moment(self.reviewStartDate).format("YYYY-MM-DD");
      payload["end_date"] = moment(self.reviewEndDate).format("YYYY-MM-DD");

      self.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.errorInProduct = false;
          if (!response.body.data.length) {
            self.errorInProduct = true;
            return;
          }
          self.productOptionsFull = response.body.data;

          self.filterKeys.brand = response.body.brand_list.sort();
          self.filterKeys.processor_type = response.body.processor_list.sort();

          if (localStorage.selected_product && !self.updateSelectedProduct)
            self.selectedProduct = JSON.parse(localStorage.selected_product);
          else {
            self.selectedProduct = self.productOptionsFull[1];
            localStorage.selected_product = JSON.stringify(self.selectedProduct);
          }
          self.filterActions();
          self.updateSelectedProduct = false;
        },
        (err) => {
          self.loader = false;
          self.errorInProduct = true;
        }
      );
    },
    filterActions() {
      this.productOptions = [];
      let brandCheck = true;
      let cpuCheck = true;
      let ratingCheck = true;
      let seriesCheck = true;

      let ratingExpMapper = {
        eq: function (a, b) {
          return a == b;
        },
        gt: function (a, b) {
          return b > a;
        },
        gte: function (a, b) {
          return b >= a;
        },
        lt: function (a, b) {
          return b < a;
        },
        lte: function (a, b) {
          return b <= a;
        },
        between: function (a1, a2, b) {
          return b >= a1 && b <= a2;
        },
      };
      for (let [ii, rr] of this.productOptionsFull.entries()) {
        if (this.brandFilter) brandCheck = this.brandFilter == rr.brand_name;
        if (this.cpuFilter) cpuCheck = this.cpuFilter == rr.processor_type;
        if (this.ratingExp != "between" && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](this.ratingInput1, rr.rating);
        else if (this.ratingExp == "between" && this.ratingInput1 && this.ratingInput1)
          ratingCheck = ratingExpMapper[this.ratingExp](
            this.ratingInput1,
            this.ratingInput2,
            rr.rating
          );

        if (this.fourKSeries && this.fiveKSeries)
          seriesCheck = rr.processor_model[0] == "4" || rr.processor_model[0] == "5";
        else if (this.fourKSeries && !this.fiveKSeries)
          seriesCheck = rr.processor_model[0] == "4";
        else if (!this.fourKSeries && this.fiveKSeries)
          seriesCheck = rr.processor_model[0] == "5";
        if (brandCheck && cpuCheck && ratingCheck && seriesCheck) {
          this.productOptions.push(rr);
        }
      }
      this.refreshReview();
    },

    format(v) {
      return this.$options.filters.format(v);
    },
  },
};
</script>

<style scoped>
.selectedProduct {
  background: #8e8d8d !important;
  color: White !important;
}
.lastUpdated {
  margin-right: 58px;
  background: grey;
  color: white;
  font-size: 15px;
  line-height: 28px;
  padding: 5px 9px 8px 8px;
}
.cardper {
  float: right;
  position: absolute;
  right: 11px;
  bottom: 0;
  font-size: 29px;
  color: white;
}
.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;

  padding-bottom: 5px;
}
.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
  line-height: 31px;
}

.mycols:first-child {
  padding-right: 2px !important;
}
.mycols:last-child {
  padding-left: 2px;
}
.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px;
}
.customselect {
  height: 34px;
  border-radius: 0;
  background: white;
  border: 1px solid silver;
  padding-left: 11px;
  padding-right: 11px;
  margin-right: 5px;
}
.eachProduct:hover {
  background: #d4d4d4;
}
#myTable th {
  text-align: center;
}
#myTable th,
#myTable td {
  border-right: 1px solid silver !important;
  border-bottom: 1px solid silver !important;
  padding-left: 2px;
  padding-right: 2px;
}
#myTable {
  border: 1px solid silver !important;
  margin-top: 12px;
}
.custom_websiteMenu {
  border: 1px solid silver;
  background: white;
  width: max-content;
  position: absolute;
  z-index: 1;
  height: 300px;
  overflow-y: scroll;
}
.custom_websiteMenuItems {
  font-size: 11px;

  color: #5c6873;
}
.custom_optgroup {
  font-weight: bolder;
  padding-left: 9px;
}
.custom_option {
  padding-left: 18px;
}
.custom_option:hover {
  background: #23a8d8;
  color: white;
  font-weight: bolder;
}
.custom_option.active {
  background: #1a88af;
  color: white;
  font-weight: bolder;
}
.custom_dropdown {
  text-transform: uppercase;
  -youbkit-touch-callout: none; /* iOS Safari */
  -youbkit-user-select: none; /* Chrome 6.0+, Safari 3.1+, Edge & Opera 15+ */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE 10+ and Edge */
  user-select: none;
}
.datebox {
  width: 11% !important;
}
.custom_dropdown_wrap {
  cursor: pointer;
  display: flex;
  border: 1px solid silver;
  background: white;
  justify-content: space-between;
  padding: 6px;
  height: 30px;
}
.custom_dropdown_title {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
